/**
 * 推广链接进站：捕获 ?ref= 推广码 → localStorage 暂存 → 未登录时自动拉起登录抽屉。
 * 登录/注册请求附带 referral_code，仅新账号注册时绑定上级（见 LoginRequestDto）。
 * 链接参数名兼容 refcode / ref / invite / code（分享页实际用 refcode，如 /zh-CN?refcode=MC5P279）。
 */
const REF_QUERY_KEYS = ['refcode', 'ref', 'invite', 'code'] as const
const REF_PATTERN = /^[A-Za-z0-9]{4,32}$/

export default defineNuxtPlugin(nuxtApp => {
  const route = useRoute()
  const { openLogin } = useAuthNav()
  const userStore = useUserStore()

  let captured = ''
  for (const key of REF_QUERY_KEYS) {
    const raw = route.query[key]
    if (typeof raw !== 'string') continue
    const code = raw.trim()
    if (REF_PATTERN.test(code)) {
      captured = code
      break
    }
  }
  if (!captured) return

  setReferralCode(captured)

  // 登录抽屉在 ClientOnly 内，等挂载完成再拉起
  nuxtApp.hooks.hook('app:mounted', () => {
    if (!userStore.isLoggedIn) openLogin()
  })
})
